import { lazy, Suspense, forwardRef } from 'react';

const LazyPageRenderer = lazy(() =>
  import(
    // eslint-disable-next-line import/no-unresolved
    '@icp/page-renderer'
  ).catch(() => ({
    default: function ErrBoundary() {
      console.error(`"@icp/page-renderer" not installed`);
      return null;
    },
  })),
);

export default forwardRef(function AsyncPageRenderer(props, ref) {
  return (
    <Suspense fallback={null}>
      <LazyPageRenderer {...props} ref={ref} />
    </Suspense>
  );
});
